// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as OrderHistoryRepoConfig$PorterinFeature from "./OrderHistoryRepoConfig.mjs";
import * as OrderHistoryDummyResponse$PorterinFeature from "./dummy-responses/OrderHistoryDummyResponse.mjs";

function orderHistory(web_tracking_id, auth_token, mobile) {
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(OrderHistoryRepoConfig$PorterinFeature.OrderHistoryResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: OrderHistoryDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

export {
  orderHistory ,
}
/* OrderHistoryRepoConfig-PorterinFeature Not a pure module */
